export default __webpack_public_path__ + "static/media/Card.77e53f90.png";